module.exports = __webpack_public_path__ + "static/ego-is-the-enemy-572b30fbf89c49606dd81e99d04d4af2.jpg";